import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import moment from 'moment';

/* Actions */
import {
	getSalesReport,
	getPIMItemInfo,
	exportProductPurchaseReport
} from '../../../redux/actions';

/* Dialogs */
import SelectedProductLinesDialog from '../../dialogs/selectedProductLinesDialog';

class ProductPurchaseReport extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showSelectedProductLinesDialog: false,

			errorMessage: '',
			confirmationMessage: '',

			groupByReportsDataCurrentYear: [],
			bkpGroupByReportsDataCurrentYear: [],

			groupByReportsDataPreviousYear: [],
			bkpGroupByReportsDataPreviousYear: [],

			batchSize: 4000,
			pimDataBatchSize: 100,
			/* Current Year Block starts */
			// Legacy
			noOfParallelCallsLegacyCurrentYear: 0,
			completedNoOfParallelCallsLegacyCurrentYear: 0,
			reportsDataLegacyCurrentYear: [],
			callsCompletedOfLegacyCurrentYear: false,

			// EBS
			noOfParallelCallsEBSCurrentYear: 0,
			completedNoOfParallelCallsEBSCurrentYear: 0,
			reportsDataEBSCurrentYear: [],
			callsCompletedOfEBSCurrentYear: false,

			// Legacy
			noOfpimDataParallelCallsLegacyCurrentYear: 0,
			completedNoOfPimDataParallelCallsLegacyCurrentYear: 0,
			pimDataLegacyCurrentYear: [],

			// EBS
			noOfpimDataParallelCallsEBSCurrentYear: 0,
			completedNoOfPimDataParallelCallsEBSCurrentYear: 0,
			pimDataEBSCurrentYear: [],
			/* Current Year Block Ends */

			/* Previous Year Block starts */
			// Legacy
			noOfParallelCallsLegacyPreviousYear: 0,
			completedNoOfParallelCallsLegacyPreviousYear: 0,
			reportsDataLegacyPreviousYear: [],
			callsCompletedOfLegacyPreviousYear: false,

			// EBS
			noOfParallelCallsEBSPreviousYear: 0,
			completedNoOfParallelCallsEBSPreviousYear: 0,
			reportsDataEBSPreviousYear: [],
			callsCompletedOfEBSPreviousYear: false,

			// Legacy
			noOfpimDataParallelCallsLegacyPreviousYear: 0,
			completedNoOfPimDataParallelCallsLegacyPreviousYear: 0,
			pimDataLegacyPreviousYear: [],

			// EBS
			noOfpimDataParallelCallsEBSPreviousYear: 0,
			completedNoOfPimDataParallelCallsEBSPreviousYear: 0,
			pimDataEBSPreviousYear: [],
			/* Previous Year Block Ends */

			currentStep: 0,
			step2Data: null,
			step3Data: null,
			previousYear: (new Date().getFullYear() - 1).toString(),
			currentMonth: (new Date().getMonth() + 1).toString(),
			yearOptions: [],
			yearToDate: [],
			currentYear: '',
			timePeriodForm: {
				param: {
					year: '',
					month: '',
					quarter: '',
					yearToDate: '',
					showForOption: 'yearToDate',
				},
				error: {}
			},
			bkpTimePeriodForm: null,
			brandsToInclude: {
				param: {
					brandMonogram: 'Monogram',
					brandGEProfileSeries: 'GE Profile Series',
					brandGE: 'GE',
					brandGECafeSeries: 'Cafe',
					brandHotpoint: 'Hotpoint',
					brandGEArtistrySeries: 'GE Artistry Series',
					brandHaier: 'Haier',
				},
				error: {}
			},
			productsToInclude: {
				param: {
					include: 'all',
					product: '',
				},
				error: {}
			},
			quarterList: [{
				name: '1st Quarter',
				value: 1
			}, {
				name: '2nd Quarter',
				value: 2
			}, {
				name: '3rd Quarter',
				value: 3
			}, {
				name: '4th Quarter',
				value: 4
			}],
			monthList: [{
				name: 'January',
				value: 1
			}, {
				name: 'February',
				value: 2
			}, {
				name: 'March',
				value: 3
			}, {
				name: 'April',
				value: 4
			}, {
				name: 'May',
				value: 5
			}, {
				name: 'June',
				value: 6
			}, {
				name: 'July',
				value: 7
			}, {
				name: 'August',
				value: 8
			}, {
				name: 'September',
				value: 9
			}, {
				name: 'October',
				value: 10
			}, {
				name: 'November',
				value: 11
			}, {
				name: 'December',
				value: 12
			}],

			productLinesList: [{
				name: 'DISHWASHER',
				value: 'DISHWASHER',
				checked: true,
			}, {
				name: 'HOME LAUNDRY',
				value: 'HOME LAUNDRY',
				checked: true,
			}, {
				name: 'RAC',
				value: 'RAC',
				checked: true,
			}, {
				name: 'RANGE',
				value: 'RANGE',
				checked: true,
			}, {
				name: 'REFRIGERATION',
				value: 'REFRIGERATION',
				checked: true,
			}, {
				name: 'WATER SYSTEMS',
				value: 'WATER SYSTEMS',
				checked: true,
			}],
		};
		this.handleDialog = this.handleDialog.bind(this);
		this.handleUpdatedProductLines = this.handleUpdatedProductLines.bind(this);
		this.updateYearToDateList = this.updateYearToDateList.bind(this);
		this.getSelectedProductLines = this.getSelectedProductLines.bind(this);
		this.goToStep = this.goToStep.bind(this);
		this.handleExport = this.handleExport.bind(this);
		this.resetConfirmationMessage = this.resetConfirmationMessage.bind(this);
	}

	handleExport(event) {
		event.preventDefault();
		const self = this;
		const { currentStep, groupByReportsDataCurrentYear, step2Data, step3Data } = self.state;
		let payload = JSON.parse(JSON.stringify(groupByReportsDataCurrentYear));
		if(currentStep === 2) {
			payload = JSON.parse(JSON.stringify(step2Data.list));
		} else if(currentStep === 3) {
			payload = JSON.parse(JSON.stringify(step3Data.list));
		}
		const finalPayload = [];
		if(payload && payload.length) {
			payload.forEach(itm => {
				finalPayload.push({
					productLine: itm.key,
					totalUnits: itm.totalUnitsCY,
					unitVariance: itm.totalUnitsPYPercentage,
					gsb: parseFloat(itm.totalGrossUnitGSBCY).toFixed(2),
					gsbVariance: itm.totalGrossUnitGSBPYPercentage,
				})
			});
			self.props.exportProductPurchaseReport(finalPayload, `accountNumber=${self.props.getSelectedAccountNumber()}`, response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					})
				} else {
					window.open(response.responseObject);
				}
			});
		}
	}

	// event for close/open dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	updateYearToDateList() {
		const self = this;
		const yearToDate = [];
		self.state.monthList.forEach((item, index) => {
			if(self.state.timePeriodForm.param.year === self.state.previousYear) {
				yearToDate.push(<option key={index} value={item.value}>{item.name}</option>)
			} else if(item.value <= self.state.currentMonth) {
				yearToDate.push(<option key={index} value={item.value}>{item.name}</option>)
			}
		});
		return yearToDate;
	}

	componentWillMount() {
		const self = this;
		const yearOptions = [];
		const currentYear = new Date().getFullYear();
		const currentMonth = new Date().getMonth() + 1;
		const completedQuarter = parseInt(currentMonth / 3, 10);
		yearOptions.push(<option key={0} value={currentYear}>{currentYear}</option>)
		yearOptions.push(<option key={1} value={currentYear - 1}>{currentYear - 1}</option>)
		self.setState({
			yearOptions,
			completedQuarter,
			timePeriodForm: {
				...self.state.timePeriodForm,
				param: {
					...self.state.timePeriodForm.param,
					year: currentYear.toString(),
					yearToDate: currentMonth.toString()
				}
			}
		}, () => {
			self.setState({
				yearToDate: self.updateYearToDateList(),
			});
		});
	}

	updateParams(formName, event) {
		//Reseting Errors on change
		const self = this;
		const name = event.target.name;
		let value = event.target.value;
		if(event.target.type === 'checkbox' && !event.target.checked) {
			value = '';
		}
		var error = self.state[formName].error;
		if(formName === 'productsToInclude') {
			if(value === 'product') {
				error = {
					...error,
					productError: '',
				};
			} else {
				delete error.productError;
			}
		}
		if(formName === 'timePeriodForm') {
			if(name === 'showForOption') {
				delete error.monthError;
				delete error.quarterError;
				if(value !== 'yearToDate') {
					error = {
						...error,
						[`${value}Error`]: '',
					};
				}
			}
		}
		for (var key in error) {
			if (error.hasOwnProperty(key)) {
				error[key] = '';
			}
		}
		self.setState({
			[formName]: {
				...self.state[formName],
				param: {
					...self.state[formName].param,
					[name]: value
				},
				error: error
			}
		}, () => {
			if(formName === 'timePeriodForm' && name === 'year') {
				const { previousYear, currentMonth } = self.state;
				let yearToDate = value === previousYear ? "12" : currentMonth;
				let month = self.state[formName].param.month;
				let quarter = self.state[formName].param.quarter;
				if (month && parseInt(month, 10) > currentMonth) {
					month = '';
				}
				if(quarter && parseInt(quarter, 10) > parseInt(self.state.currentMonth / 3, 10)) {
					quarter = '';
				}
				self.setState({
					yearToDate: self.updateYearToDateList(),
					[formName]: {
						...self.state[formName],
						param: {
							...self.state[formName].param,
							yearToDate,
							month,
							quarter
						}
					},
				});
			}
		});
	}

	checkIfAllParallelCallsCompleted(whichData, whichYear) {
		const self = this;
		const noOfParallelCalls = self.state[`noOfParallelCalls${whichData}${whichYear}`],
			completedNoOfParallelCalls = self.state[`completedNoOfParallelCalls${whichData}${whichYear}`],
			reportsData = self.state[`reportsData${whichData}${whichYear}`];
		if(noOfParallelCalls > 0 && noOfParallelCalls === completedNoOfParallelCalls) {
			// make parallel calls to get pim details
			let skuListForPim = [];
			reportsData.forEach(itm => {
				itm.INV_ITEM && skuListForPim.push(itm.INV_ITEM);
			});
			skuListForPim = _.uniq(skuListForPim);
			skuListForPim = _.chunk(skuListForPim, self.state.pimDataBatchSize);
			self.setState({
				[`noOfpimDataParallelCalls${whichData}${whichYear}`]: skuListForPim.length,
				[`completedNoOfPimDataParallelCalls${whichData}${whichYear}`]: 0,
				[`pimData${whichData}${whichYear}`]: [],
			}, () => {
				if (skuListForPim.length > 0) {
					skuListForPim.forEach(skuList => {
						self.props.getPIMItemInfo(skuList, "requestType=getPIMItemInfo", response => {
							const responseObject = response.responseObject ? response.responseObject : null;
							if(response.status) {
								let pimData = self.state[`pimData${whichData}${whichYear}`];
								pimData = pimData.concat(responseObject);
								self.setState({
									[`completedNoOfPimDataParallelCalls${whichData}${whichYear}`]: self.state[`completedNoOfPimDataParallelCalls${whichData}${whichYear}`] + 1,
									[`pimData${whichData}${whichYear}`]: pimData
								}, () => {
									self.checkIfAllPimDataParallelCallsCompleted(whichData, whichYear);
								});
							}
						});
					});
				} else {
					self.setState({
						[`completedNoOfPimDataParallelCalls${whichData}${whichYear}`]: 0
					}, () => {
						self.checkIfAllPimDataParallelCallsCompleted(whichData, whichYear);
					});
				}
			});
		} else if(noOfParallelCalls === 0) {
		   self.setState({
			   [`noOfpimDataParallelCalls${whichData}${whichYear}`]: 0,
			   [`completedNoOfPimDataParallelCalls${whichData}${whichYear}`]: 0,
			   [`pimData${whichData}${whichYear}`]: [],
		   }, () => {
			   self.checkIfAllPimDataParallelCallsCompleted(whichData, whichYear);
		   });
		}
	}

	checkIfAllPimDataParallelCallsCompleted(whichData, whichYear) {
		const self = this;
		const noOfpimDataParallelCalls = self.state[`noOfpimDataParallelCalls${whichData}${whichYear}`],
			completedNoOfPimDataParallelCalls = self.state[`completedNoOfPimDataParallelCalls${whichData}${whichYear}`];
		if(noOfpimDataParallelCalls === completedNoOfPimDataParallelCalls) {
			self.setState({
				[`callsCompletedOf${whichData}${whichYear}`]: true
			}, () => {
				self.callBackAfterDataFetch();
			});
		}
	}

	callBackAfterDataFetch() {
		const self = this;
		const {
			callsCompletedOfLegacyCurrentYear,
			callsCompletedOfEBSCurrentYear,
			callsCompletedOfLegacyPreviousYear,
			callsCompletedOfEBSPreviousYear,
			productLinesList
		} = self.state;
		if(callsCompletedOfLegacyCurrentYear && callsCompletedOfEBSCurrentYear && callsCompletedOfLegacyPreviousYear && callsCompletedOfEBSPreviousYear) {
			const { pimDataLegacyPreviousYear, pimDataEBSPreviousYear, reportsDataLegacyPreviousYear, reportsDataEBSPreviousYear } = self.state;
			const pimDataPY = pimDataLegacyPreviousYear.concat(pimDataEBSPreviousYear);
			let reportsDataPY = reportsDataLegacyPreviousYear.concat(reportsDataEBSPreviousYear);
			reportsDataPY = JSON.parse(JSON.stringify(reportsDataPY));
			let finalRecords = [];
			reportsDataPY.forEach(item => {
				const data = pimDataPY.find(itm => itm.item_number === item.INV_ITEM);
				if(data && productLinesList.find(itm => itm.value === data.geego_product_dept_name)) {
					item.geego_product_dept_name = data.geego_product_dept_name;
					item.geego_brand = data.geego_brand;
					item.item_catalog_group = data.item_catalog_group;
					finalRecords.push(item);
				}
			});
			let dataPY = window.convertToArrayOfObject(_.groupBy(finalRecords, "geego_product_dept_name"), true);
			const bkpDataPY = JSON.parse(JSON.stringify(dataPY));
			dataPY = self.filterData(JSON.parse(JSON.stringify(dataPY)));

			// Current Year data
			const { pimDataLegacyCurrentYear, pimDataEBSCurrentYear, reportsDataLegacyCurrentYear, reportsDataEBSCurrentYear } = self.state;
			const pimDataCY = pimDataLegacyCurrentYear.concat(pimDataEBSCurrentYear);
			let reportsDataCY = reportsDataLegacyCurrentYear.concat(reportsDataEBSCurrentYear);
			reportsDataCY = JSON.parse(JSON.stringify(reportsDataCY));
			finalRecords = [];
			reportsDataCY.forEach(item => {
				const data = pimDataCY.find(itm => itm.item_number === item.INV_ITEM);
				if(data && productLinesList.find(itm => itm.value === data.geego_product_dept_name)) {
					item.geego_product_dept_name = data.geego_product_dept_name;
					item.geego_brand = data.geego_brand;
					item.item_catalog_group = data.item_catalog_group;
					finalRecords.push(item);
				}
			});
			let dataCY = window.convertToArrayOfObject(_.groupBy(finalRecords, "geego_product_dept_name"), true);
			const bkpDataCY = JSON.parse(JSON.stringify(dataCY));
			dataCY = self.filterData(JSON.parse(JSON.stringify(dataCY)));
			dataCY.forEach((item, index) => {
				let totalUnitsCY = 0;
				let totalGrossUnitGSBCY = 0;
				item.list.forEach(itm => {
					if(itm.INV_ITEM_QUANTITY) {
						totalUnitsCY += itm.INV_ITEM_QUANTITY;
					}
					if(itm.INV_UNIT_GSB) {
						totalGrossUnitGSBCY += itm.INV_UNIT_GSB;
					}
				});
				// calculate previousYear Data
				const {
					totalUnitsPY,
					totalGrossUnitGSBPY,
					totalUnitsPYPercentage,
					totalGrossUnitGSBPYPercentage
				} = self.getPreviousYearData(item.key, totalUnitsCY, totalGrossUnitGSBCY, dataPY);
				item.totalUnitsCY = totalUnitsCY;
				item.totalGrossUnitGSBCY = totalGrossUnitGSBCY;
				item.totalUnitsPY = totalUnitsPY;
				item.totalGrossUnitGSBPY = totalGrossUnitGSBPY;
				item.totalUnitsPYPercentage = totalUnitsPYPercentage;
				item.totalGrossUnitGSBPYPercentage = totalGrossUnitGSBPYPercentage;
			});
			self.setState({
				currentStep: 1,
				groupByReportsDataCurrentYear: dataCY,
				bkpGroupByReportsDataCurrentYear: JSON.parse(JSON.stringify(bkpDataCY)),
				groupByReportsDataPreviousYear: dataPY,
				bkpGroupByReportsDataPreviousYear: JSON.parse(JSON.stringify(bkpDataPY)),

				bkpTimePeriodForm: JSON.parse(JSON.stringify(self.state.timePeriodForm)),
				confirmationMessage: "Updated Filter Results",
				filterCompleted: true
			}, () => {
				let {
					productsToInclude: {
						param: {
							include
						}
					}
				} = self.state;
				if (include === 'product') {
					const data = self.filterData(JSON.parse(JSON.stringify(self.state.groupByReportsDataCurrentYear)));
					if(data && data.length > 0) {
						self.goToStep(2, 1, data[0], null, () => {
							self.goToStep(3, 2, self.state.step2Data.list[0], null, () => {
								self.resetConfirmationMessage();
							});
						});
					}
				} else {
					self.resetConfirmationMessage();
				}
			});
		}
	}

	getSelectedBrands() {
		const self = this;
		const {
			brandsToInclude: {
				param: {
					brandMonogram,
					brandGEProfileSeries,
					brandGE,
					brandGECafeSeries,
					brandHotpoint,
					brandGEArtistrySeries,
					brandHaier,
				},
			}
		} = self.state;
		const selectedBrands = [];
		brandMonogram && selectedBrands.push(brandMonogram);
		brandGEProfileSeries && selectedBrands.push(brandGEProfileSeries);
		brandGE && selectedBrands.push(brandGE);
		brandGECafeSeries && selectedBrands.push(brandGECafeSeries);
		brandHotpoint && selectedBrands.push(brandHotpoint);
		brandGEArtistrySeries && selectedBrands.push(brandGEArtistrySeries);
		brandHaier && selectedBrands.push(brandHaier);
		return selectedBrands;
	}

	getSelectedProductLines() {
		const self = this;
		const {
			productLinesList,
			productsToInclude: {
				param: {
					include,
				}
			},
		} = self.state;
		const selectedProductLine = [];
		productLinesList.forEach(itm => {
			if(include === 'all') {
				selectedProductLine.push(itm.value);
			} else if(include === 'selected' && itm.checked) {
				selectedProductLine.push(itm.value);
			}
		});
		// if length === 0 it means product radio is selected
		return selectedProductLine;
	}

	filterData(data) {
		const self = this;
		const finalData = [];
		// check if any brand is selected
		const brandsList = self.getSelectedBrands();
		const productLineList = self.getSelectedProductLines();
		const { product, include } = self.state.productsToInclude.param;
		data.forEach(item => {
			const filteredList = [];
			item.list.forEach(itm => {
				if (brandsList.indexOf(itm.geego_brand) !== -1 &&
					(
						(include === 'all') ||
						(include === 'selected' && productLineList.indexOf(itm.geego_product_dept_name) !== -1) ||
						(include === 'product' && itm.INV_ITEM.toUpperCase().indexOf(product.toUpperCase()) === 0)
					)
				) {
					filteredList.push(itm);
				}
			});
			filteredList.length > 0 && finalData.push({
				...item,
				list: filteredList
			});
		});
		return finalData;
	}

	handleRunReport(event) {
		event.preventDefault();
		const self = this;
		let formError = false;
		let {
			productsToInclude: {
				param,
				error
			},
			timePeriodForm
		} = self.state;

		if (param.include === 'product') {
			if(param.product === '' || param.product.length < 3) {
				error.productError = 'error';
				formError = true;
			} else {
				error.productError = '';
			}
		}
		if(timePeriodForm.param.showForOption !== 'yearToDate') {
			if(timePeriodForm.param[timePeriodForm.param.showForOption] === '') {
				timePeriodForm.error[timePeriodForm.param.showForOption+'Error'] = 'error';
				formError = true;
			} else {
				timePeriodForm.error[timePeriodForm.param.showForOption+'Error'] = '';
			}
		}
		self.setState({
			productsToInclude: {
				param,
				error
			},
			timePeriodForm: {
				...timePeriodForm,
				error: timePeriodForm.error
			},
			filterCompleted: false,
		}, () => {
			if(!formError) {
				const { timePeriodForm, bkpTimePeriodForm } = self.state;
				// reset all data first
				self.setState({
					currentStep: 0,

					/* Current Year Block starts */
					// Legacy
					noOfParallelCallsLegacyCurrentYear: 0,
					completedNoOfParallelCallsLegacyCurrentYear: 0,
					reportsDataLegacyCurrentYear: [],
					callsCompletedOfLegacyCurrentYear: false,

					// EBS
					noOfParallelCallsEBSCurrentYear: 0,
					completedNoOfParallelCallsEBSCurrentYear: 0,
					reportsDataEBSCurrentYear: [],
					callsCompletedOfEBSCurrentYear: false,

					// Legacy
					noOfpimDataParallelCallsLegacyCurrentYear: 0,
					completedNoOfPimDataParallelCallsLegacyCurrentYear: 0,
					pimDataLegacyCurrentYear: [],

					// EBS
					noOfpimDataParallelCallsEBSCurrentYear: 0,
					completedNoOfPimDataParallelCallsEBSCurrentYear: 0,
					pimDataEBSCurrentYear: [],
					/* Current Year Block Ends */

					/* Previous Year Block starts */
					// Legacy
					noOfParallelCallsLegacyPreviousYear: 0,
					completedNoOfParallelCallsLegacyPreviousYear: 0,
					reportsDataLegacyPreviousYear: [],
					callsCompletedOfLegacyPreviousYear: false,

					// EBS
					noOfParallelCallsEBSPreviousYear: 0,
					completedNoOfParallelCallsEBSPreviousYear: 0,
					reportsDataEBSPreviousYear: [],
					callsCompletedOfEBSPreviousYear: false,

					// Legacy
					noOfpimDataParallelCallsLegacyPreviousYear: 0,
					completedNoOfPimDataParallelCallsLegacyPreviousYear: 0,
					pimDataLegacyPreviousYear: [],

					// EBS
					noOfpimDataParallelCallsEBSPreviousYear: 0,
					completedNoOfPimDataParallelCallsEBSPreviousYear: 0,
					pimDataEBSPreviousYear: [],
					/* Previous Year Block Ends */
				}, () => {
					if(JSON.stringify(timePeriodForm) !== JSON.stringify(bkpTimePeriodForm)) {
						self.getData('Legacy', 'CurrentYear');
						self.getData('EBS', 'CurrentYear');
						self.getData('Legacy', 'PreviousYear');
						self.getData('EBS', 'PreviousYear');
					} else {
						// Logic to filter data from backuped data
						let filteredDataCurrentYearData = self.filterData(JSON.parse(JSON.stringify(self.state.bkpGroupByReportsDataCurrentYear)));
						const filteredDataPreviousYearData = self.filterData(JSON.parse(JSON.stringify(self.state.bkpGroupByReportsDataPreviousYear)));
						filteredDataCurrentYearData.forEach((item, index) => {
							let totalUnitsCY = 0;
							let totalGrossUnitGSBCY = 0;
							item.list.forEach(itm => {
								if(itm.INV_ITEM_QUANTITY) {
									totalUnitsCY += itm.INV_ITEM_QUANTITY;
								}
								if(itm.INV_UNIT_GSB) {
									totalGrossUnitGSBCY += itm.INV_UNIT_GSB;
								}
							});
							// calculate previousYear Data
							const {
								totalUnitsPY,
								totalGrossUnitGSBPY,
								totalUnitsPYPercentage,
								totalGrossUnitGSBPYPercentage
							} = self.getPreviousYearData(item.key, totalUnitsCY, totalGrossUnitGSBCY, filteredDataPreviousYearData);
							item.totalUnitsCY = totalUnitsCY;
							item.totalGrossUnitGSBCY = totalGrossUnitGSBCY;
							item.totalUnitsPY = totalUnitsPY;
							item.totalGrossUnitGSBPY = totalGrossUnitGSBPY;
							item.totalUnitsPYPercentage = totalUnitsPYPercentage;
							item.totalGrossUnitGSBPYPercentage = totalGrossUnitGSBPYPercentage;
						});
						self.setState({
							currentStep: 1,
							groupByReportsDataCurrentYear: filteredDataCurrentYearData,
							confirmationMessage: 'Updated Filter Results',
							filterCompleted: true,
						}, () => {
							let {
								productsToInclude: {
									param: {
										include
									}
								}
							} = self.state;
							if (include === 'product') {
								const data = self.filterData(JSON.parse(JSON.stringify(self.state.groupByReportsDataCurrentYear)));
								if(data && data.length > 0) {
									self.goToStep(2, 1, data[0], null, () => {
										self.goToStep(3, 2, self.state.step2Data.list[0], null, () => {
											self.resetConfirmationMessage();
										});
									});
								}
							} else {
								self.resetConfirmationMessage();
							}
						});
					}
				});
			}
		});
	}

	getData(whichData, whichYear) {
		const self = this;
		let {
			timePeriodForm: {
				param: {
					year,
					month,
					quarter,
					yearToDate,
					showForOption
				}
			}
		} = self.state;
		if(showForOption === 'yearToDate') {
			month = '';
			quarter = '';
		} else if(showForOption === 'month') {
			yearToDate = '';
			quarter = '';
		} else if(showForOption === 'quarter') {
			yearToDate = '';
			month = '';
		}
		self.props.getSalesReport(`requestType=getReport${whichData}Count&accountNumber=${self.props.getSelectedAccountNumber()}&legacyCustcode=${self.props.getLegacyCustCode()}&year=${whichYear === 'CurrentYear'? year : (year - 1)}&month=${month}&quarter=${quarter}&yearToDate=${yearToDate}`, response => {
			if(response && response.status) {
				response.responseObject = response.responseObject && JSON.parse(response.responseObject);
				if(response.responseObject && response.responseObject.length > 0) {
					const recordsCount = response.responseObject[0]['COUNT(1)'];
					const noOfParallelCalls = Math.ceil(recordsCount / self.state.batchSize);
					if(noOfParallelCalls > 0) {
						self.setState({
							[`noOfParallelCalls${whichData}${whichYear}`]: noOfParallelCalls,
							[`reportsData${whichData}${whichYear}`]: [],
							[`completedNoOfParallelCalls${whichData}${whichYear}`]: 0,
						}, () => {
							let rowStart = 1,
								rowEnd = self.state.batchSize;
							_.times(noOfParallelCalls, () => {
								if(rowEnd > recordsCount) {
									rowEnd = recordsCount;
								}
								self.props.getSalesReport(`requestType=getReport${whichData}Data&rowStart=${rowStart}&rowEnd=${rowEnd}&accountNumber=${self.props.getSelectedAccountNumber()}&legacyCustcode=${self.props.getLegacyCustCode()}&year=${whichYear === 'CurrentYear'? year : (year - 1)}&month=${month}&quarter=${quarter}&yearToDate=${yearToDate}`, resp => {
									if(resp.status) {
										resp.responseObject = resp.responseObject && JSON.parse(resp.responseObject);
										let reportsData = self.state[`reportsData${whichData}${whichYear}`];
										reportsData = reportsData.concat(resp.responseObject);
										reportsData = reportsData.filter(itm => itm.INV_ITEM);
										self.setState({
											[`completedNoOfParallelCalls${whichData}${whichYear}`]: self.state[`completedNoOfParallelCalls${whichData}${whichYear}`] + 1,
											[`reportsData${whichData}${whichYear}`]: reportsData
										}, () => {
											self.checkIfAllParallelCallsCompleted(whichData, whichYear);
										})
									} else {
										browserHistory.push('/error')
									}
								});
								rowStart += self.state.batchSize;
								rowEnd += self.state.batchSize;
							});
						});
					} else {
						self.setState({
							[`noOfParallelCalls${whichData}${whichYear}`]: 0,
							[`reportsData${whichData}${whichYear}`]: [],
							[`completedNoOfParallelCalls${whichData}${whichYear}`]: 0,
						}, () => {
							self.checkIfAllParallelCallsCompleted(whichData, whichYear);
						})
					}
				}
			} else {
				browserHistory.push('/error')
			}
		});
	}

	handleSelectedProductLinesOnly(event) {
		event && event.preventDefault();
		const self = this;
		self.setState({
			bkpProductLinesList: JSON.parse(JSON.stringify(self.state.productLinesList)),
		}, () => {
			self.updateParams('productsToInclude', { target : { value: 'selected', name: 'include' } });
			self.handleDialog('SelectedProductLinesDialog', true, event)
		});
	}

	handleUpdatedProductLines(performAction, updatedProductLinesList, event) {
		event && event.preventDefault();
		const self = this;
		let productLinesList = JSON.parse(JSON.stringify(self.state.bkpProductLinesList));
		if(performAction) {
			productLinesList = JSON.parse(JSON.stringify(updatedProductLinesList));
		}
		self.setState({
			productLinesList
		}, () => {
			self.handleDialog('SelectedProductLinesDialog', false, event);
		});
	}

	goToStep(nextStep, previousStep, data, event, callback) {
		event && event.preventDefault();
		const self = this;
		if(data) {
			if(nextStep === 2 && previousStep === 1) {
				let groupByCatalogGroup = window.convertToArrayOfObject(_.groupBy(data.list, "item_catalog_group"), true);
				let previousYear=self.state.groupByReportsDataPreviousYear.find(itm => itm.key === data.key);
				let currentYear=self.state.groupByReportsDataCurrentYear.find(itm => itm.key === data.key);
				let dataPY = previousYear ? previousYear : currentYear;
				if(dataPY) {
					dataPY = window.convertToArrayOfObject(_.groupBy(dataPY.list, "item_catalog_group"), true);
				}
				groupByCatalogGroup.forEach((item, index) => {
					let totalUnitsCY = 0;
					let totalGrossUnitGSBCY = 0;
					item.list.forEach(itm => {
						if(itm.INV_ITEM_QUANTITY) {
							totalUnitsCY += itm.INV_ITEM_QUANTITY;
						}
						if(itm.INV_UNIT_GSB) {
							totalGrossUnitGSBCY += itm.INV_UNIT_GSB;
						}
					});
					// calculate previousYear Data
					const {
						totalUnitsPY,
						totalGrossUnitGSBPY,
						totalUnitsPYPercentage,
						totalGrossUnitGSBPYPercentage
					} = self.getPreviousYearData(item.key, totalUnitsCY, totalGrossUnitGSBCY, dataPY);
					item.totalUnitsCY = totalUnitsCY;
					item.totalGrossUnitGSBCY = totalGrossUnitGSBCY;
					item.totalUnitsPY = totalUnitsPY;
					item.totalGrossUnitGSBPY = totalGrossUnitGSBPY;
					item.totalUnitsPYPercentage = totalUnitsPYPercentage;
					item.totalGrossUnitGSBPYPercentage = totalGrossUnitGSBPYPercentage;
				});
				data = {
					key: data.key,
					list: groupByCatalogGroup,
				};
			} else if(nextStep === 3 && previousStep === 2) {
				let groupByCatalogGroup1 = window.convertToArrayOfObject(_.groupBy(data.list, "INV_ITEM"), true);
				let previousYear=self.state.groupByReportsDataPreviousYear.find(itm => itm.key === self.state.step2Data.key);
				let currentYear=self.state.groupByReportsDataCurrentYear.find(itm => itm.key === self.state.step2Data.key);
				let dataPY1 = previousYear ? previousYear : currentYear;
				if(dataPY1) {
					dataPY1 = window.convertToArrayOfObject(_.groupBy(dataPY1.list, "item_catalog_group"), true);
					dataPY1 = dataPY1.find(itm => itm.key === data.key);
					if(dataPY1) {
						dataPY1 = window.convertToArrayOfObject(_.groupBy(dataPY1.list, "INV_ITEM"), true);
					}
				}
				groupByCatalogGroup1.forEach((item, index) => {
					let totalUnitsCY = 0;
					let totalGrossUnitGSBCY = 0;
					item.list.forEach(itm => {
						if(itm.INV_ITEM_QUANTITY) {
							totalUnitsCY += itm.INV_ITEM_QUANTITY;
						}
						if(itm.INV_UNIT_GSB) {
							totalGrossUnitGSBCY += itm.INV_UNIT_GSB;
						}
					});
					// calculate previousYear Data
					const {
						totalUnitsPY,
						totalGrossUnitGSBPY,
						totalUnitsPYPercentage,
						totalGrossUnitGSBPYPercentage
					} = self.getPreviousYearData(item.key, totalUnitsCY, totalGrossUnitGSBCY, dataPY1);
					item.totalUnitsCY = totalUnitsCY;
					item.totalGrossUnitGSBCY = totalGrossUnitGSBCY;
					item.totalUnitsPY = totalUnitsPY;
					item.totalGrossUnitGSBPY = totalGrossUnitGSBPY;
					item.totalUnitsPYPercentage = totalUnitsPYPercentage;
					item.totalGrossUnitGSBPYPercentage = totalGrossUnitGSBPYPercentage;
				});
				groupByCatalogGroup1 = _.sortBy(groupByCatalogGroup1, ['key']);
				data = {
					key: data.key,
					list: groupByCatalogGroup1,
				};
			}
		}
		self.setState({
			currentStep: nextStep,
			[`step${nextStep}Data`]: data
		}, () => {
			callback && callback();
		});
	}

	getPreviousYearData(keyCY, totalUnitsCY, totalGrossUnitGSBCY, groupByReportsDataPreviousYear) {
		let totalUnitsPY = 0;
		let totalGrossUnitGSBPY = 0;
		let totalUnitsPYPercentage = 0;
		let totalGrossUnitGSBPYPercentage = 0;
		const itemPY = groupByReportsDataPreviousYear.find(it => it.key === keyCY);
		if(itemPY) {
			itemPY.list.forEach(itm => {
				if(itm.INV_ITEM_QUANTITY) {
					totalUnitsPY += itm.INV_ITEM_QUANTITY;
				}
				if(itm.INV_UNIT_GSB) {
					totalGrossUnitGSBPY += itm.INV_UNIT_GSB;
				}
			});
			totalUnitsPYPercentage = totalUnitsPY && parseFloat(totalUnitsPY) ? parseFloat((totalUnitsCY - totalUnitsPY) / totalUnitsPY * 100).toFixed(2) : "100";
			totalGrossUnitGSBPYPercentage = totalGrossUnitGSBPY && parseFloat(totalGrossUnitGSBPY) ? parseFloat((totalGrossUnitGSBCY - totalGrossUnitGSBPY) / totalGrossUnitGSBPY * 100).toFixed(2) : "100";
		} else {
			totalUnitsPYPercentage = 100;
			totalGrossUnitGSBPYPercentage = 100;
		}
		return {
			totalUnitsPY,
			totalGrossUnitGSBPY,
			totalUnitsPYPercentage,
			totalGrossUnitGSBPYPercentage
		}
	}

	resetConfirmationMessage() {
		const self = this;
		setTimeout(() => {
			self.setState({
				confirmationMessage: '',
			})
		}, 3000);
	}

	render() {
		const self = this;
		const {
			currentStep,
			step2Data,
			step3Data,
			groupByReportsDataCurrentYear,
			brandsToInclude: {
				param: {
					brandMonogram,
					brandGEProfileSeries,
					brandGE,
					brandGECafeSeries,
					brandHotpoint,
					brandGEArtistrySeries,
					brandHaier,
				}
			},
			productsToInclude: {
				param: {
					include,
					product
				},
				error
			},
			timePeriodForm,
			confirmationMessage,
			filterCompleted
		} = self.state;
		let step1Col2Sum = 0;
		let step1Col3Sum = 0;
		let step1Col4Sum = 0;
		let step1Col5Sum = 0;
		let step2Col2Sum = 0;
		let step2Col3Sum = 0;
		let step2Col4Sum = 0;
		let step2Col5Sum = 0;
		let step3Col2Sum = 0;
		let step3Col3Sum = 0;
		let step3Col4Sum = 0;
		let step3Col5Sum = 0;
		return (
			<div>
				<div className="push">
					<h1 className="pageTitle">Product Purchase &amp; Sales Report</h1>
				</div>
				<form action="" onSubmit={this.handleRunReport.bind(this)}>
					<table cellPadding={0} cellSpacing={0} width="100%">
						<tbody>
							<tr style={{verticalAlign: 'top'}}>
								<td style={{borderRight: '1px solid #ccc', width: '36%', padding: '0 20px 0 0'}}>
									<div className="colHead1">Time Period</div>
									<table style={{margin: 0}}>
										<tbody>
											<tr>
												<td className="bold">Year:</td>
												<td>
													<select id="year" name="year" onChange={this.updateParams.bind(this, 'timePeriodForm')} value={this.state.timePeriodForm.param.year}>
														{this.state.yearOptions}
													</select>
												</td>
												<td></td>
											</tr>
											<tr>
												<td className="bold">Show report for:</td>
												<td>
													<input type="radio" defaultChecked={this.state.timePeriodForm.param.showForOption === 'month'} value="month" onClick={this.updateParams.bind(this, 'timePeriodForm')} name="showForOption" id="month" /><label htmlFor="month">Month</label>
												</td>
												<td>
													<select className={timePeriodForm.error.monthError} style={{width: '100%'}} name="month" onChange={this.updateParams.bind(this, 'timePeriodForm')} value={this.state.timePeriodForm.param.month}>
														<option value="">-- Select --</option>
														{this.state.yearToDate}
													</select>
												</td>
											</tr>
											<tr>
												<td />
												<td>
													<input type="radio" defaultChecked={this.state.timePeriodForm.param.showForOption === 'quarter'} value="quarter" onClick={this.updateParams.bind(this, 'timePeriodForm')} name="showForOption" id="quarter" /><label htmlFor="quarter">Quarter</label>
												</td>
												<td>
													<select className={timePeriodForm.error.quarterError} style={{width: '100%'}} name="quarter" onChange={this.updateParams.bind(this, 'timePeriodForm')} value={this.state.timePeriodForm.param.quarter}>
														<option value="">-- Select --</option>
														{self.state.quarterList.map((item, index) => {
															if(self.state.timePeriodForm.param.year !== self.state.previousYear) {
																if(item.value <= parseInt(self.state.currentMonth / 3, 10)) {
																	return <option key={index} value={item.value}>{item.name}</option>;
																} else {
																	return null;
																}
															} else {
																return <option key={index} value={item.value}>{item.name}</option>
															}
														})}
													</select>
												</td>
											</tr>
											<tr>
												<td />
												<td>
													<input type="radio" defaultChecked={this.state.timePeriodForm.param.showForOption === 'yearToDate'} value="yearToDate" onClick={this.updateParams.bind(this, 'timePeriodForm')} name="showForOption" id="yearToDate" /><label htmlFor="yearToDate">Year to Date</label>
												</td>
												<td>
													<select style={{width: '100%'}} name="yearToDate" onChange={this.updateParams.bind(this, 'timePeriodForm')} value={this.state.timePeriodForm.param.yearToDate}>
														{this.state.yearToDate}
													</select>
												</td>
											</tr>
										</tbody>
									</table>
								</td>
								<td style={{borderRight: '1px solid #ccc', padding: '0 20px'}}>
									<div className="colHead1">Brands to Include</div>
									<div className="fullCell">
										<input type="checkbox" value='Monogram' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandMonogram" id="brandMonogram" defaultChecked={brandMonogram ? true : false} />
										<label htmlFor="brandMonogram">Monogram</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='GE Profile Series' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandGEProfileSeries" id="brandGEProfileSeries" defaultChecked={brandGEProfileSeries ? true : false} />
										<label htmlFor="brandGEProfileSeries">GE Profile Series</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='GE' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandGE" id="brandGE" defaultChecked={brandGE ? true : false} />
										<label htmlFor="brandGE">GE</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='Cafe' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandGECafeSeries" id="brandGECafeSeries" defaultChecked={brandGECafeSeries ? true : false} />
										<label htmlFor="brandGECafeSeries">Cafe</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='Hotpoint' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandHotpoint" id="brandHotpoint" defaultChecked={brandHotpoint ? true : false} />
										<label htmlFor="brandHotpoint">Hotpoint</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='GE Artistry Series' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandGEArtistrySeries" id="brandGEArtistrySeries" defaultChecked={brandGEArtistrySeries ? true : false} />
										<label htmlFor="brandGEArtistrySeries">GE Artistry Series</label>
									</div>
									<div className="fullCell">
										<input type="checkbox" value='Haier' onChange={this.updateParams.bind(this, 'brandsToInclude')} name="brandHaier" id="brandHaier" defaultChecked={brandHaier ? true : false} />
										<label htmlFor="brandHaier">Haier</label>
									</div>
								</td>
								<td style={{padding: '0 20px', width: '40%'}}>
									<div className="colHead1">Products to Include</div>
									<div className="fullCell">
										<input type="radio" checked={include === 'all'} value="all" name="include" id="includeAll" onClick={this.updateParams.bind(this, 'productsToInclude')} />
										<label htmlFor="includeAll">All Product Lines</label>
									</div>
									<div className="fullCell">
										<input type="radio" checked={include === 'selected'} value="selected" name="include" id="includeSelected" onClick={this.updateParams.bind(this, 'productsToInclude')} />
										<label htmlFor="includeSelected"><a href="" onClick={ self.handleSelectedProductLinesOnly.bind(this) }>Selected Product Lines Only</a></label>
									</div>
									<div className="fullCell">
										<input type="radio" checked={include === 'product'} value="product" name="include" id="includeProduct" onClick={this.updateParams.bind(this, 'productsToInclude')} />
										<label htmlFor="includeProduct">Product</label>
										<input onFocus={() => self.updateParams('productsToInclude', { target : { value: 'product', name: 'include' } })} type="text" onChange={this.updateParams.bind(this, 'productsToInclude')} className={error.productError} placeholder="Enter Product Number" name="product" style={{marginLeft: '5px'}} />
									</div>
									{error.productError && product.length < 3 && <div>
										<p className="red bold">Please enter at least 3 characters.</p>
									</div>}
								</td>
							</tr>
							<tr>
								<td />
								<td className="txt-ctr">
									<br />
									<input type="submit" value="Run Report" className="blueButton" />
								</td>
								<td />
							</tr>
						</tbody>
					</table>
				</form>
				<p className="bold">{confirmationMessage}</p>
				<div className={currentStep > 0 ? "searchResults" : ""}>
					{currentStep > 0 && <p style={{margin: '5px 0', fontSize: '0.9em'}}>Report Created {moment().format('MMMM D, YYYY')}</p>}
					{currentStep === 1 &&
						<div>
					        <h3 style={{width: '49.95%', float: 'left', margin: '5px 0'}}>Purchase &amp; Sales History</h3>
					        <p className="textRight" style={{width: '49.95%', float: 'right', margin: '5px 0'}}>
					        	<a href="" onClick={this.props.handlePrint} className="printPurchaseSalesHistoryResults withIcon withPrintIcon noUnderline uppercase bold">Print</a>
					          	&nbsp;&nbsp;&nbsp;&nbsp;
								<a href="" onClick={(e) => self.handleExport(e)} className="exportPurchaseSalesHistoryResults withIcon withExportIcon noUnderline uppercase bold">Export</a>
					        </p>
					        <div className="clear" />
					        <table className="dataTable" width="100%">
								<thead>
									<tr>
										<th>Product Line / Type</th>
										<th className="txt-ctr">Total Units</th>
										<th className="txt-ctr">Unit Variance (V%)</th>
										<th className="txt-ctr">Gross Sales Billed (GSB)</th>
										<th className="txt-ctr">GSB Variance (V%)</th>
									</tr>
								</thead>
				          		<tbody>
									{filterCompleted && groupByReportsDataCurrentYear.length === 0 &&
										<tr>
											<td colSpan={ 5 }>
												No records found for selected filters.
											</td>
										</tr>
									}
									{filterCompleted && groupByReportsDataCurrentYear.map((item, index) => {
										const {
											totalUnitsCY,
											totalGrossUnitGSBCY,
											totalUnitsPY,
											totalGrossUnitGSBPY,
											totalUnitsPYPercentage,
											totalGrossUnitGSBPYPercentage,
										} = item;
										step1Col2Sum += totalUnitsCY;
										step1Col3Sum += parseFloat(totalUnitsPY);
										step1Col4Sum += totalGrossUnitGSBCY;
										step1Col5Sum += parseFloat(totalGrossUnitGSBPY);
										return <tr key={index}>
											<td><a href="" onClick={(e) => self.goToStep(2, 1, item, e)}>{item.key}</a></td>
											<td className="txt-ctr">{totalUnitsCY}</td>
											<td className="txt-ctr">{totalUnitsPYPercentage}%</td>
											<td className="txt-ctr">{self.props.formatMoney(parseFloat(totalGrossUnitGSBCY).toFixed(2), 2, ".", ",", false, "$")}</td>
											<td className="txt-ctr">{totalGrossUnitGSBPYPercentage}%</td>
							            </tr>
									})}
									{filterCompleted && groupByReportsDataCurrentYear.length > 0 && <tr className="subfooterX">
										<td>Total</td>
										<td className="txt-ctr">{step1Col2Sum}</td>
										<td className="txt-ctr">
											{step1Col3Sum ? parseFloat((step1Col2Sum - step1Col3Sum) / step1Col3Sum * 100).toFixed(2) : 100}%
										</td>
										<td className="txt-ctr">{self.props.formatMoney(parseFloat(step1Col4Sum).toFixed(2), 2, ".", ",", false, "$")}</td>
										<td className="txt-ctr">
											{step1Col5Sum ? parseFloat((step1Col4Sum - step1Col5Sum) / step1Col5Sum * 100).toFixed(2) : 100}%
										</td>
									</tr>}
					          </tbody>
					        </table>
					    </div>
					}
					{currentStep === 2 &&
						<div>
					        <h3 style={{width: '49.95%', float: 'left', margin: '5px 0'}}>
								<a href="" onClick={(e) => self.goToStep(1, 2, null, e)}>Purchase &amp; Sales History</a>
								&gt; {step2Data && step2Data.key}
							</h3>
							<p className="textRight" style={{width: '49.95%', float: 'right', margin: '5px 0'}}>
					        	<a href="" onClick={this.props.handlePrint} className="printPurchaseSalesHistoryResults withIcon withPrintIcon noUnderline uppercase bold">Print</a>
					          	&nbsp;&nbsp;&nbsp;&nbsp;
								<a href="" onClick={(e) => self.handleExport(e)} className="exportPurchaseSalesHistoryResults withIcon withExportIcon noUnderline uppercase bold">Export</a>
					        </p>
					        <div className="clear" />
					        <table className="dataTable" width="100%">
								<thead>
									<tr>
										<th>Product Line / Type</th>
										<th className="txt-ctr">Total Units</th>
										<th className="txt-ctr">Unit Variance (V%)</th>
										<th className="txt-ctr">Gross Sales Billed (GSB)</th>
										<th className="txt-ctr">GSB Variance (V%)</th>
									</tr>
								</thead>
					          	<tbody>
									{step2Data && step2Data.list.map((item, index) => {
										const {
											totalUnitsCY,
											totalGrossUnitGSBCY,
											totalUnitsPY,
											totalGrossUnitGSBPY,
											totalUnitsPYPercentage,
											totalGrossUnitGSBPYPercentage,
										} = item;
										step2Col2Sum += totalUnitsCY;
										step2Col3Sum += parseFloat(totalUnitsPY);
										step2Col4Sum += totalGrossUnitGSBCY;
										step2Col5Sum += parseFloat(totalGrossUnitGSBPY);
										return <tr key={index}>
											<td><a href="" onClick={(e) => self.goToStep(3, 2, item, e)}>{item.key}</a></td>
											<td className="txt-ctr">{totalUnitsCY}</td>
											<td className="txt-ctr">{totalUnitsPYPercentage}%</td>
											<td className="txt-ctr">{self.props.formatMoney(parseFloat(totalGrossUnitGSBCY).toFixed(2), 2, ".", ",", false, "$")}</td>
											<td className="txt-ctr">{totalGrossUnitGSBPYPercentage}%</td>
										</tr>
									})}
									<tr className="subfooterX">
										<td>Total</td>
										<td className="txt-ctr">{step2Col2Sum}</td>
										<td className="txt-ctr">
											{step2Col3Sum ? parseFloat((step2Col2Sum - step2Col3Sum) / step2Col3Sum * 100).toFixed(2) : 100}%
										</td>
										<td className="txt-ctr">{self.props.formatMoney(parseFloat(step2Col4Sum).toFixed(2), 2, ".", ",", false, "$")}</td>
										<td className="txt-ctr">
											{step2Col5Sum ? parseFloat((step2Col4Sum - step2Col5Sum) / step2Col5Sum * 100).toFixed(2) : 100}%
										</td>
									</tr>
								</tbody>
							</table>
				      	</div>
					}
					{currentStep === 3 &&
						<div>
					        <h3 style={{width: '69.95%', float: 'left', margin: '5px 0'}}>
								<a href="" onClick={(e) => self.goToStep(1, 3, null, e)}>Purchase &amp; Sales History</a>
								&gt; <a href="" onClick={(e) => self.goToStep(2, 3, step2Data, e)}>{step2Data && step2Data.key}</a>
								<span className="unbold grey">&gt; {step3Data && step3Data.key}</span>
					        </h3>
							<p className="textRight" style={{width: '49.95%', float: 'right', margin: '5px 0'}}>
					        	<a href="" onClick={this.props.handlePrint} className="printPurchaseSalesHistoryResults withIcon withPrintIcon noUnderline uppercase bold">Print</a>
					          	&nbsp;&nbsp;&nbsp;&nbsp;
								<a href="" onClick={(e) => self.handleExport(e)} className="exportPurchaseSalesHistoryResults withIcon withExportIcon noUnderline uppercase bold">Export</a>
					        </p>
					        <div className="clear" />
					        <table className="dataTable" width="100%">
								<thead>
									<tr>
										<th>Product Line / Type</th>
										<th className="txt-ctr">Total Units</th>
										<th className="txt-ctr">Unit Variance (V%)</th>
										<th className="txt-ctr">Gross Sales Billed (GSB)</th>
										<th className="txt-ctr">GSB Variance (V%)</th>
									</tr>
								</thead>
								<tbody>
									{step3Data && step3Data.list.map((item, index) => {
										const {
											totalUnitsCY,
											totalGrossUnitGSBCY,
											totalUnitsPY,
											totalGrossUnitGSBPY,
											totalUnitsPYPercentage,
											totalGrossUnitGSBPYPercentage,
										} = item;
										step3Col2Sum += totalUnitsCY;
										step3Col3Sum += parseFloat(totalUnitsPY);
										step3Col4Sum += totalGrossUnitGSBCY;
										step3Col5Sum += parseFloat(totalGrossUnitGSBPY);
										return <tr key={index}>
											<td>{item.key}</td>
											<td className="txt-ctr">{totalUnitsCY}</td>
											<td className="txt-ctr">{totalUnitsPYPercentage}%</td>
											<td className="txt-ctr">{self.props.formatMoney(parseFloat(totalGrossUnitGSBCY).toFixed(2), 2, ".", ",", false, "$")}</td>
											<td className="txt-ctr">{totalGrossUnitGSBPYPercentage}%</td>
										</tr>
									})}
									<tr className="subfooterX">
										<td>Total</td>
										<td className="txt-ctr">{step3Col2Sum}</td>
										<td className="txt-ctr">
											{step3Col5Sum ? parseFloat((step3Col2Sum - step3Col3Sum) / step3Col3Sum * 100).toFixed(2) : 100}%
										</td>
										<td className="txt-ctr">{self.props.formatMoney(parseFloat(step3Col4Sum).toFixed(2), 2, ".", ",", false, "$")}</td>
										<td className="txt-ctr">
											{step3Col5Sum ? parseFloat((step3Col4Sum - step3Col5Sum) / step3Col5Sum * 100).toFixed(2) : 100}%
										</td>
									</tr>
								</tbody>
							</table>
				      	</div>
					}
				</div>
				{self.state.showSelectedProductLinesDialog &&
					<SelectedProductLinesDialog
						handleDialog={self.handleDialog}
						productLinesList={self.state.productLinesList}
						handleUpdatedProductLines={self.handleUpdatedProductLines}
						showDialog={true}
					/>
				}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getSalesReport: (payload, callback) => dispatch(getSalesReport(payload, callback)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	exportProductPurchaseReport: (payload, params, response) => dispatch(exportProductPurchaseReport(payload, params, response)),
});

ProductPurchaseReport = connect(mapStateToProps, mapDispatchToProps)(ProductPurchaseReport);
export default ProductPurchaseReport;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/ProductPurchaseReport/index.js